module.exports = __webpack_public_path__ + "img/3.858f09f8.png";